import clsx from "clsx";

export default function Spinner({ size = "md", className = "" }) {
  const sz = { sm: "w-5 h-5", md: "w-7 h-7", lg: "w-12 h-12", xl: "w-16 h-16" }[size];
  return (
    <div className={clsx("flex items-center justify-center", className)}>
      <div className={clsx("relative", sz)}>
        {/* Outer ring */}
        <div
          className="absolute inset-0 rounded-full border-2 border-transparent animate-spin"
          style={{
            borderTopColor: "#8b5cf6",
            borderRightColor: "#06b6d4",
            filter: "drop-shadow(0 0 4px rgba(139,92,246,0.5))",
          }}
        />
        {/* Inner ring (reverse) */}
        <div
          className="absolute inset-1.5 rounded-full border-2 border-transparent"
          style={{
            borderBottomColor: "#ec4899",
            borderLeftColor: "transparent",
            animation: "spin 0.8s linear infinite reverse",
            filter: "drop-shadow(0 0 3px rgba(236,72,153,0.4))",
          }}
        />
        {/* Center dot */}
        <div
          className="absolute inset-0 flex items-center justify-center"
        >
          <div
            className="w-1.5 h-1.5 rounded-full"
            style={{ background: "#8b5cf6", boxShadow: "0 0 6px #8b5cf6", animation: "glow-pulse 1.5s ease-in-out infinite" }}
          />
        </div>
      </div>
    </div>
  );
}
